import React from 'react';
interface RefundPolicyModalProps {
  onClose: () => void;
}
export const RefundPolicyModal: React.FC<RefundPolicyModalProps> = ({
  onClose
}) => {
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-199">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full max-h-[80vh] overflow-y-auto" data-id="element-200">
        <div className="p-6" data-id="element-201">
          <div className="flex justify-between items-center mb-4" data-id="element-202">
            <h2 className="text-xl font-bold text-gray-800" data-id="element-203">Refund Policy</h2>
            <button onClick={onClose} className="text-gray-500 hover:text-gray-700" data-id="element-204">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-205">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-206" />
              </svg>
            </button>
          </div>
          <div className="prose prose-sm" data-id="element-207">
            <div className="mb-4 p-4 bg-red-50 border-l-4 border-red-400 rounded" data-id="element-208">
              <p className="font-bold text-red-800" data-id="element-209">
                Important: Due to copyright protection, we cannot accept returns
                of opened books.
              </p>
            </div>
            <h3 data-id="element-210">Digital Products</h3>
            <p data-id="element-211">
              All sales of digital products are final and non-refundable. Due to
              the nature of digital products, we cannot offer refunds once the
              download link has been provided.
            </p>
            <h3 data-id="element-212">Physical Products</h3>
            <p data-id="element-213">
              If your physical book arrives damaged, please contact our customer
              service team within 7 days of receipt with photos of the damage.
              We will arrange for a replacement at no additional cost.
            </p>
            <h3 data-id="element-214">Shipping Errors</h3>
            <p data-id="element-215">
              If you receive the wrong product, please contact us within 7 days
              of receipt. We will arrange for the correct item to be shipped and
              provide a return label for the incorrect item.
            </p>
            <h3 data-id="element-216">Cancellations</h3>
            <p data-id="element-217">
              Orders may be cancelled within 24 hours of purchase if the order
              has not yet been processed for shipping. Please contact customer
              service immediately if you need to cancel an order.
            </p>
            <div className="mt-6 p-4 bg-blue-50 border-l-4 border-blue-400 rounded" data-id="element-218">
              <p className="font-medium" data-id="element-219">
                For any refund inquiries, please contact our customer service
                team at support@voicesoffreedomus.com
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
};